import { Skeleton } from '@components/ui/skeleton';

export const SearchResultsSkeleton = () => {
  return (
    <div className="relative flex h-full w-full flex-col gap-2 p-2">
      {Array.from({ length: 10 }).map((_, index) => (
        <Skeleton key={index} className="h-[80px] w-full" />
      ))}
    </div>
  );
};
